import SceButton from '../../../../../../../Common/CommonComponents/sceButton';
import SceCpcCheckBox from '../../../../../../common/sceCpcCheckbox';
import SceCpcPagination from '../../../../../../common/Pagination';
import CppErrCard from './cppErrCard/cppErrCard';
import classes from './setNotificationCpp.scss';
import FocusTrap from 'focus-trap-react';
import { getLocalizedStrings } from '../../../notificationLocalizedStrings';
import SceSelectBox from '../../../../../../common/FilterDropdown/filterDropdown';

class SetNotificationBulkCPP extends React.Component {
    constructor(props) {
        super(props);
        this.strings = getLocalizedStrings('CppBulkNotification');
        this.state={
            selectAllCheck: this.props.selectAllCheck,selectedServiceAccounts: [...this.props.selectedServiceAccounts],
            unSelectedAccounts: this.props.unSelectedAccounts, selectAllFlow:this.props.selectAllFlow, currentPage: 1,  coOffset: 1, networkErr: false,
            eligibleAccountCount:0,counter:0, currentSelAccount:this.props.currentSelectedServiceAccount, selectedType: this.props.isTurnOn ? this.strings.notEnrolled : this.strings.alreadyEnrolled,  dropDownError:false,
            options:[{value:this.strings.notEnrolled,name: this.strings.notEnrolled},
                {value:this.strings.alreadyEnrolled,name: this.strings.alreadyEnrolled},]
        };
        this.serviceAccountsPerPage = 10;
        let closeIcon;
        this.closeIcon=drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Close.svg';
        
    }

    componentWillMount() {
        //Get list of contracts from backend.      
        this.getListofServiceAccounts();       
    }

    getListofServiceAccounts = () => {
       
        let updatedState = {...this.state};
      
        updatedState.selectAllCheck = true;   
        let isTurnOn = this.props.isTurnOn;
        let currentSelectedServiceAccount = this.props.currentSelectedServiceAccount;
        let notEnrolled = this.strings.notEnrolled;
        app.centralizedService.getServiceAccountList(this.props.contractAccountNumber, this.state.coOffset,this.props.selectedServiceAccounts[0].contractBpNumber,this.state.selectedType).then(
            (response) => {

                //Determine which contract is selected and/or enrolled 
                _.each(response.contractResults, function(eachContract){

                    if(updatedState.selectAllFlow) eachContract['isSelected'] = 
                        !updatedState.unSelectedAccounts.has(eachContract.contractNumber);
                        else 
                        {  
                             eachContract['isSelected'] = updatedState.selectedServiceAccounts.some((eachAccount) => {
                                if(eachAccount.contractNumber === eachContract.contractNumber) {
                                    return true;
                                } else return false;
                            }) ? true : false;
                        }
                    eachContract['isEnrolled'] = updatedState.selectedType === notEnrolled ? false : true;  
                    // To get the count of eligible account counts. if its not enrolled increment count.
                    eachContract['isEnrolled'] ? null : updatedState.eligibleAccountCount++;  
                });
                updatedState['serviceAccountList'] = response.contractResults;
                updatedState['contractNumbercount'] = response.contractNumbercount;
                updatedState.networkErr = false;
                if(updatedState.selectAllFlow && updatedState.contractNumbercount>10){
                    updatedState.counter=updatedState.contractNumbercount-updatedState.unSelectedAccounts.size;}
                else
                   updatedState.counter=updatedState.selectedServiceAccounts.length;
               //select all is true if select all flow is true
                updatedState.selectAllCheck= updatedState.selectAllFlow ? 
                !updatedState.unSelectedAccounts.size : updatedState.contractNumbercount===updatedState.counter;

                this.setState(updatedState);
            },(error) =>{
                this.setState({networkErr: true});
            }
        );
    }
    
    handlePageChange = (selectedPageNumber) => {
        //Determine offset. coOffset = (selected page number - )*10
        this.setState({coOffset: ((selectedPageNumber-1)*10+1)}, () => {
            //Get list of contracts from backend as per the page number.
            this.getListofServiceAccounts();
        });
        document.getElementById('cpp_selectAll').scrollIntoView();
    }

    handleCheckClick = (isSelectAll, index) => {       
        let updatedState = {...this.state};
        let isTurnOn = this.props.isTurnOn;

    if(!isSelectAll) {
        //When a specific contract is checked/unchecked
        //If its a turn on flow and selected contract is not enrolled then toggle the isSelected status.
        isTurnOn ? !updatedState.serviceAccountList[index].isEnrolled ? updatedState.serviceAccountList[index].isSelected = !updatedState.serviceAccountList[index].isSelected : null :
        //It its not a turn on flow and the selected contract is enrolled then toggle the isSelected status.
        updatedState.serviceAccountList[index].isEnrolled ? updatedState.serviceAccountList[index].isSelected = !updatedState.serviceAccountList[index].isSelected : null;
        if(!updatedState.selectAllFlow) {//checking whether select all  is checked or not 
              //  If the contract is selected then push it to selectedServiceAccounts array else remove the contract from selectedServiceAccounts array.
                updatedState.serviceAccountList[index].isSelected ? 
                (updatedState.selectedServiceAccounts.push(updatedState.serviceAccountList[index])) :

                (updatedState.selectedServiceAccounts = _.reject(updatedState.selectedServiceAccounts, function(eachAccount){
                    return eachAccount.contractNumber === updatedState.serviceAccountList[index].contractNumber;
                }));
            }
        else {// when select all  check box is checked and  then unchecking/checking  checkbox
                !updatedState.serviceAccountList[index].isSelected ?
               ( updatedState.unSelectedAccounts.set(updatedState.serviceAccountList[index].contractNumber, updatedState.serviceAccountList[index]),updatedState.selectedAccountsCount--):
               ( updatedState.unSelectedAccounts.delete(updatedState.serviceAccountList[index].contractNumber));
                updatedState.selectAllCheck = !updatedState.unSelectedAccounts.size;
               
              }  
     if ((parseInt(updatedState.contractNumbercount)) === updatedState.counter) updatedState.selectAllCheck = true;
     else updatedState.selectAllCheck = false;
    } 
    
    else {
        //When selected all is checked/unchecked
        //Toggle select all checkbox state.
        updatedState.selectAllCheck = !updatedState.selectAllCheck;
        updatedState.selectAllFlow = updatedState.selectAllCheck ? true : false;//checking whether select all is clickedchange
        updatedState.unSelectedAccounts.clear();
            _.each(updatedState.serviceAccountList, function(eachServiceAccount)  {
            
            //If its a turn on flow and the contract is not enrolled then toggle isSelected status.

            //ANC-823: To disable default selected contract when select all check/uncheck performed.
            eachServiceAccount.contractNumber !== updatedState.currentSelAccount ? 
            isTurnOn ? !eachServiceAccount.isEnrolled ? eachServiceAccount.isSelected = updatedState.selectAllCheck : null:
            //If its not a turn on flow and the contract is enrolled then toggle isSelected status.
            eachServiceAccount.isEnrolled ? eachServiceAccount.isSelected = updatedState.selectAllCheck : null : null;  
        });

        updatedState.selectAllCheck?  
            updatedState.contractNumbercount>10 ?
            updatedState.selectedServiceAccounts =[...this.props.selectedServiceAccounts] :
            updatedState.selectedServiceAccounts =_.uniq(updatedState.selectedServiceAccounts.concat(updatedState.serviceAccountList), false, (eachAccount)=>{return eachAccount.contractNumber;}):
        updatedState.selectedServiceAccounts =[...this.props.selectedServiceAccounts];
     }
    if(updatedState.selectAllFlow && updatedState.contractNumbercount>10){
        updatedState.counter=updatedState.contractNumbercount-updatedState.unSelectedAccounts.size;}
    else
       updatedState.counter=updatedState.selectedServiceAccounts.length;
   this.setState(updatedState);
}

  //handing drop down
    selectOpitonHandler = (e) => {
        this.setState({selectedType:e.value,dropDownError:false,coOffset: 1}, () => {
            //Get list of contracts from backend as per the filter dropdown.
            this.getListofServiceAccounts();
        });
    }

    getDisplayServiceAccountList = () =>{
        let displayserviceAccountList = [];
        //Create a list of checkboxes for every contract in serviceAccountList array.
        if(!_.isEmpty(this.state.serviceAccountList)){            
            displayserviceAccountList = this.state.serviceAccountList.map((eachServiceAccount, index)=>{
                //If turn on flow and the contract is already enrolled then mention Already enrolled.
                //If not turn on flow and the contract is not enrolled then mention Not enrolled.
                let checkboxOption =
                <div className={classes.sceServiceAccountCheckList}>
                    <div>
                    {eachServiceAccount.address+' - Acct. '+eachServiceAccount.contractNumber}
                    </div>
                </div>;
                //If turn on flow and the contract is already enrolled then disable the checkbox.
                //If not turn on flow and the contract is not enrolled then disable checkbox. 
                let isDisabled = this.props.isTurnOn ? eachServiceAccount.isEnrolled || eachServiceAccount.contractNumber ===  this.props.currentSelectedServiceAccount ? true : false : !eachServiceAccount.isEnrolled || eachServiceAccount.contractNumber ===  this.props.currentSelectedServiceAccount ? true : false;
                return (
                    <div className="col-xs-12">
                        <SceCpcCheckBox id={'cpp_serviceAccount_'+eachServiceAccount.contractNumber} handleClick={() => this.handleCheckClick(false, index)} selectedOptions={eachServiceAccount.isSelected} 
                        options={checkboxOption} disabled={isDisabled} />
                    </div>
                );
            });
        }
        return displayserviceAccountList;
    }
    
    handleAddAccounts = () => {
     this.props.getServcieAccountsList(this.state.selectedServiceAccounts,this.state.selectAllFlow,this.state.unSelectedAccounts,this.state.contractNumbercount);
    }

    getViewToShow = () => {
        //If MS call fails show error card.
        if(this.state.networkErr) {
            return (
                <div className='col-xs-12'>
                    <CppErrCard onFormhandler={this.getListofServiceAccounts} />
                </div>
            );
        } else {            
            let displayserviceAccountList = this.getDisplayServiceAccountList();
            let totalPages = Math.ceil(this.state.contractNumbercount / this.serviceAccountsPerPage);
            return (
                <div>
                    <span className={classes.cppFilterdiv}>
                    <span>{this.strings.filterBy}</span>
                    <div  className={classes.cppFilter}>
                        <SceSelectBox 
                            id={"cppFilterdropdown"}
                            selectBoxData={this.state.options}
                            handleClick={this.selectOpitonHandler}
                            displayDefaultText={false}
                            defaultText={this.state.selectedType}
                            selected={this.state.selectedType} 
                        /> 
                    </div>
                    </span>  
                    {( this.state.selectedType === this.strings.alreadyEnrolled  && this.props.isTurnOn ) ||
                    ( this.state.selectedType === this.strings.notEnrolled  && !this.props.isTurnOn)
                    ? null: <div className={'row '+classes.selectall}> 
                    <div className="col-xs-12">
                    <SceCpcCheckBox  id={'cpp_selectAll'} handleClick={() => this.handleCheckClick(true)} selectedOptions={this.state.selectAllCheck}                 
                       options={<div className='row'><div className="col-xs-5">{"Select All"}</div><div className="col-xs-7">{this.state.counter}{" of "}{this.state.contractNumbercount}{" Acct. selected"}</div></div>}  />
                   </div></div>}
                <div className='col-xs-12'> 
                    <div className={'row '+classes.serviceAccBlock}> 
                        <div className='col-xs-12' >
                            <div className={'row sce-space-md '+classes.serviceAccountList}>
                                {displayserviceAccountList}
                            </div>
                            <div className='row'>
                                <div className={'col-xs-12'}>
                                    <SceCpcPagination pageCount={totalPages} getCurrentIndex={(e) => this.handlePageChange(e)} pageScale={5} value={this.state.currentPage} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={'row sce-space-md'}>
                        <div className={'col-xs-12 '+classes.sceServiceAccountAddAccountsBtn}>
                            <SceButton buttonType={'primary'} value={'Add Accounts'} iconType='rightArrow' onClick={this.handleAddAccounts} />
                        </div>
                    </div>
                </div>
                </div>
            );
        }
    }

    render() {
        let getViewToShow = this.getViewToShow();
        return (
            <FocusTrap 
            focusTrapOptions={{
               allowOutsideClick: true,
           }}
           >
            <div className='row'>
                <div className='col-xs-12'>
                    <div className='row'>
                        <div className={'col-xs-12 ' + classes.sceSetNotificationMainHeader}>{this.props.headerText}<button className={classes.iconClose} onClick={this.props.closePopUp} ><img  src={this.closeIcon} alt="Close Icon"  /></button></div>
                        <div className={'col-xs-12'}><a className={classes.sceSmLink} onClick={(e)=>this.props.navigateBackFromServiceAccount(e)} 
                        href="javascript::void(0)" >{'< Back'}</a></div>
                        <div className={'col-xs-12 sce-space-md '+classes.sceSetNotificationMainHeader}>{'Please select Service Accounts'}</div>                     
                    </div>
                </div>
                {getViewToShow}
            </div>
            </FocusTrap>
            
        );
    }
}

export default SetNotificationBulkCPP;